;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('afterRender', afterRender)

  /* @ngInject */
  function afterRender ($timeout) {
    var def = {
      restrict: 'A',
      terminal: true,
      transclude: false,
      link: function (scope, element, attrs) {
        $timeout(scope.$eval(attrs.afterRender), 0) // Calling a scoped method
      }
    }
    return def
  }
})()
